import { defineStore } from 'pinia'
import { login as apiLogin, register as apiRegister, getProfile } from '../services/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('token') || null,
    loading: false,
    error: null
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
    currentUser: (state) => state.user
  },

  actions: {
    async login(credentials) {
      this.loading = true
      this.error = null
      try {
        const response = await apiLogin(credentials)
        if (response.success) {
          this.user = response.user
          this.token = response.token
          localStorage.setItem('token', this.token)
          localStorage.setItem('user', JSON.stringify(this.user))
          return { success: true }
        }
        this.error = response.message || '登录失败'
        return { success: false, error: this.error }
      } catch (error) {
        this.error = error.message || '登录失败'
        return { success: false, error: this.error }
      } finally {
        this.loading = false
      }
    },

    async register(userData) {
      this.loading = true
      this.error = null
      try {
        const response = await apiRegister(userData)
        if (response.success) {
          this.user = response.user
          this.token = response.token
          localStorage.setItem('token', this.token)
          localStorage.setItem('user', JSON.stringify(this.user))
          return { success: true }
        }
        this.error = response.message || '注册失败'
        return { success: false, error: this.error }
      } catch (error) {
        this.error = error.message || '注册失败'
        return { success: false, error: this.error }
      } finally {
        this.loading = false
      }
    },

    async fetchProfile() {
      if (!this.token) return
      try {
        const response = await getProfile()
        if (response.success) {
          this.user = response.user
        }
      } catch (error) {
        if (error.status === 401) {
          this.logout()
        }
      }
    },

    logout() {
      this.user = null
      this.token = null
      this.error = null
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },

    initializeAuth() {
      const token = localStorage.getItem('token')
      const user = localStorage.getItem('user')
      if (token && user) {
        this.token = token
        this.user = JSON.parse(user)
        this.fetchProfile()
      }
    }
  }
})
